import CNLogo from "../../components/CNLogo";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faYoutube,
  faFacebook,
  faInstagram,
  faLinkedin,
  faWhatsapp,
} from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { allFooterLinks } from "../../components/Footer/links";
import { Dialog } from "@headlessui/react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { faCopyright } from "@fortawesome/free-regular-svg-icons";

const FooterLandingPage = () => {
  const navigate = useNavigate();
  return (
    <>
      <div className="bottom-0 bg-midnight pt-6 text-center text-white">
        <div className="flex h-[44px] items-center justify-center gap-4 md:h-[60px]">
          <div className="flex h-full items-center justify-center rounded-lg bg-white p-2 md:p-4">
            <div className="flex w-fit items-center gap-2  rounded-md bg-white/10">
              <img
                src="https://img.learntube.ai/public-assets/post-payment-updates/image%2011.svg?updatedAt=1728356261811"
                loading="eager"
                alt=""
                width={31}
                height={31}
                className="h-full w-full xl:h-[42px] xl:w-[42px]"
              />
              <p className="text-md font-medium text-black md:text-[18px]">
                LearnTube.ai
              </p>
            </div>
          </div>
          <div className=" h-full w-[160px] border-l-2 border-[#797979] md:w-[232px]">
            <img
              src="https://developers.google.com/static/youtube/images/developed-with-youtube-sentence-case-light.png"
              className=" h-full w-full object-cover"
            ></img>
          </div>
        </div>
        <div className="ml-4 border-gray-800 py-5 text-left md:mx-6">
          <div className="grid cursor-pointer grid-cols-2 gap-3 md:flex md:flex-row md:justify-center md:gap-10">
            <div className="hidden md:flex md:flex-row md:items-center md:gap-4 md:text-xl">
              <a
                target="_blank"
                rel="noreferrer"
                href={allFooterLinks.termsConditions}
                className="md:justify-start"
              >
                Terms and Conditions
              </a>
              <span className="text-6xl">&#183;</span>
              <a
                target="_blank"
                rel="noreferrer"
                href={allFooterLinks.privacyPolicy}
                className=""
              >
                Privacy Policy
              </a>
              <span className="text-6xl">&#183;</span>
              <a
                target="_blank"
                rel="noreferrer"
                href={allFooterLinks.aboutUs}
                className=""
              >
                About Us
              </a>
            </div>
          </div>
        </div>

        <div className="mx-4 mb-6 flex flex-row items-center justify-evenly gap-2 text-xs md:hidden">
          <a
            target="_blank"
            rel="noreferrer"
            href={allFooterLinks.termsConditions}
            className="md:justify-start"
          >
            Terms and Conditions
          </a>
          <a
            target="_blank"
            rel="noreferrer"
            href={allFooterLinks.privacyPolicy}
            className=""
          >
            Privacy Policy
          </a>
          <a
            target="_blank"
            rel="noreferrer"
            href={allFooterLinks.aboutUs}
            className=""
          >
            About Us
          </a>
        </div>
        <div className="text-[14px] font-medium md:text-[16px]">
          <FontAwesomeIcon icon={faCopyright} size="lg" /> 2026 BeNinja
          Solutions Pvt. Ltd. (CIN U80904MH2017PTC295152)
        </div>
        <div className="mt-6 text-xs md:flex md:cursor-pointer md:items-center md:justify-between md:p-6 md:text-sm">
          <div className="ml-4 flex justify-center gap-8 md:hidden">
            <a
              target="_blank"
              rel="noreferrer"
              href={allFooterLinks.youtube}
              className="text-white md:mr-6"
            >
              <FontAwesomeIcon
                className="md:transform md:hover:translate-y-2"
                size="xl"
                icon={faYoutube}
              />
            </a>
            <a
              target="_blank"
              rel="noreferrer"
              href={allFooterLinks.facebook}
              className="text-white md:mr-6"
            >
              <FontAwesomeIcon size="xl" icon={faFacebook} />
            </a>
            <a
              target="_blank"
              rel="noreferrer"
              href={allFooterLinks.instagram}
              className="text-white md:mr-6"
            >
              <FontAwesomeIcon size="xl" icon={faInstagram} />
            </a>
            <a
              target="_blank"
              rel="noreferrer"
              href={allFooterLinks.linkedin}
              className="text-white md:mr-6"
            >
              <FontAwesomeIcon size="xl" icon={faLinkedin} />
            </a>
          </div>

          <div className="mt-7 flex flex-col items-center gap-2 pb-4 md:hidden">
            <div className="text-center text-white md:mr-6">
              <span className="font-bold text-white">
                For Queries Contact Us:
              </span>
            </div>
            <div className="text-white md:mr-6">
              <FontAwesomeIcon size="xl" icon={faEnvelope} />
              <span className="text-white "> hello@careerninja.in</span>
            </div>
            <a
              href={"https://wa.me/919160950649"}
              target="_blank"
              rel="noreferrer"
              className="text-white md:mr-6"
            >
              <FontAwesomeIcon size="xl" icon={faWhatsapp} />
              <span className="text-white "> +919160950649</span>
            </a>
            <p className="hidden text-supertiny md:block md:text-xs ">
              © 2022 CareerNinja
            </p>
          </div>
          <div className="hidden md:flex ">
            <div className="text-white md:mr-6">
              <span className="font-bold text-white">
                For Queries Contact Us:
              </span>
            </div>
            <div className="text-white md:mr-6">
              <FontAwesomeIcon size="xl" icon={faEnvelope} />
              <span className="font-bold text-white">
                {" "}
                hello@careerninja.in
              </span>
            </div>
            <a
              target="_blank"
              rel="noreferrer"
              href={"https://wa.me/919160950649"}
              className="text-white md:mr-6"
            >
              <FontAwesomeIcon size="xl" icon={faWhatsapp} />
              <span className="font-bold text-white"> +919160950649</span>
            </a>
          </div>
          <div className="hidden justify-center md:flex">
            <a
              target="_blank"
              rel="noreferrer"
              href={allFooterLinks.youtube}
              className="text-white md:mr-6"
            >
              <FontAwesomeIcon size="xl" icon={faYoutube} />
            </a>
            <a
              target="_blank"
              rel="noreferrer"
              href={allFooterLinks.facebook}
              className="text-white md:mr-6"
            >
              <FontAwesomeIcon size="xl" icon={faFacebook} />
            </a>
            <a
              target="_blank"
              rel="noreferrer"
              href={allFooterLinks.instagram}
              className="text-white md:mr-6"
            >
              <FontAwesomeIcon size="xl" icon={faInstagram} />
            </a>
            <a
              target="_blank"
              rel="noreferrer"
              href={allFooterLinks.linkedin}
              className="text-white md:mr-6"
            >
              <FontAwesomeIcon size="xl" icon={faLinkedin} />
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default FooterLandingPage;
